export const EntitlementBanner = () => (
  <div className="alert alert-warning m-3" role="alert">
    Approval workflow is available only on paid Premium plans.
  </div>
);
